<template>
  <div class="container">
    <common-title :titleName="readonly ? '查看信息' : '填写信息'" bcColor="#F7F8FC" :zIndex="2001" />
    <div v-if="!readonly" class="tipInfo">从哔哩哔哩下单的课程，请如实填写以下信息</div>
    <div v-else-if="!expressNo" class="toggleBtn" @click="toggle">更改信息</div>
    <div v-if="readonly && showEditAddress" class="toggleBtn" @click="editAddress">修改地址</div>
    <order-form v-if="!readonly" :detail="detail" :onSuccess="onSuccess" />
    <order-detail v-else :detail="detail"/>
    <Loading ref="load" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import Loading from '@/components/loading/loading.vue';
import {
  reqBilibiliOrderCheck,
  reqBilibiliOrderDetail,
  reqBilibiliOrdereliverDetail,
} from '@/api/bilibiliShipments/index';
import orderDetail from './components/orderDetail.vue';
import orderForm from './components/orderForm.vue';

export default {
  data() {
    return {
      detail: {
        wxUserName: '',
        subjectName: '',
        orderImgList: [],
        buserId: '',
        borderNo: '',
        consignee: '',
        phone: '',
        addressDetail: '',
        productName: '',
      },
      courseId: this.$route.query.courseId || 1452,
      readonly: false,
      expressNo: undefined,
      showEditAddress: false,
    };
  },
  created() {

  },
  mounted() {
    this.getOrderDetail();
    this.$refs.load.show = true;
  },
  methods: {
    ...mapActions(['set_order_address']),
    editAddress() {
      this.$router.push({
        path: `/bilibili-shipments/edit-address?courseId=${this.courseId}`,
      });
    },
    toggle() {
      this.readonly = false;
    },
    onSuccess() {
      this.$router.push({
        path: `/bilibili-shipments/result?courseId=${this.courseId}`,
      });
    },
    async getOrderDetail() {
      const res = await reqBilibiliOrderCheck(this.courseId || 1452);
      if (res.code === 0) {
        const { isFillOrderInfo, borderNo } = res.data;
        if (!isFillOrderInfo) {
          this.readonly = false;
          this.$refs.load.show = false;
          return;
        }
        const result = await reqBilibiliOrderDetail(borderNo, this.courseId || 1452);
        if (result.code === 0) {
          this.detail = result.data;
          this.readonly = true;
          this.set_order_address(result?.data ? result.data : {});
          this.$refs.load.show = false;
        }
        const resVal = await reqBilibiliOrdereliverDetail(borderNo);
        if (resVal.code === 0) {
          this.expressNo = resVal.data[0]?.expressNo;
          if (resVal?.data[0]?.expressNo) {
            this.showEditAddress = true;
          }
        }
      }
    },
  },
  components: {
    CommonTitle,
    orderDetail,
    orderForm,
    Loading,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 100px;
  background: #F7F8FC;
  font-size: 22px;

  .tipInfo {
    margin: 36px;
    font-size: 25px;
    color: #333333;
    line-height: 38px;

    .subject {
      color: #FF7F41;
    }
  }

  .toggleBtn {
    width: 100%;
    padding: 36px;
    text-align: end;
    font-size: 25px;
    color: #FF7F41;
  }

  .box {
    margin: 0 36px 22px;
    background: #FFFFFF;
    border-radius: 14px;

    .title {
      padding-top: 33px;
      font-size: 33px;
      font-weight: 500;
      color: #333333;

      .icon {
        display: inline-block;
        width: 7px;
        height: 29px;
        margin-right: 29px;
        background: #FF7F41;
      }
    }

    .subTitle {
      font-size: 25px;
      margin-bottom: 14px;
      margin-top: 29px;
    }

    .content {
      padding: 36px;

      .tooltip {
        font-size: 22px;
        color: #999999;
        line-height: 31px;
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 750px;
    height: 167px;
    background: #FFFFFF;
    box-shadow: 0px -4px 18px 0px rgba(0,0,0,0.07);

    .btn {
      width: 678px;
      height: 80px;
      margin: 22px 0 0 36px;
      background: #FF7F41;
      border-radius: 45px;
      color: #fff;
      font-size: 29px;
      text-align: center;
      line-height: 80px;
    }
  }
}
</style>
